/* get tab */
export const GET_TAB = "GET_TAB";

/* get Request Question */
export const NEW_REQUEST_PAGE = "NEW_REQUEST_PAGE";
export const NEW_REQUEST_QUESTION1 = "NEW_REQUEST_QUESTION1";
export const NEW_REQUEST_QUESTION2 = "NEW_REQUEST_QUESTION2";
export const NEW_REQUEST_QUESTION3 = "NEW_REQUEST_QUESTION3";
